import React, { useState, useEffect, useRef } from "react";
import moment from "moment-timezone";
import {
  Header,
  Table,
  Tab,
  Popup,
  Icon,
  Dropdown,
  Input,
  Pagination,
  Button,
  Message,
} from "semantic-ui-react";
import { Link, useNavigate } from "react-router-dom";
import css from "../../assets/styles/templateList/index.module.scss";
import "./index.css";
import tableCss from "../../assets/styles/shared/tables.module.scss";
import gridCss from "../../assets/styles/shared/grids.module.scss";
import {
  DeleteIconComponent,
  EditIconComponent,
  LeftArrowIconComponent,
  RightArrowIconComponent,
} from "../iconComponents";

import PollResult from "./PollResult";
import axios from "axios";

import Clipboard from "react-clipboard.js";
import { generateHtml } from "../polls/constants/generateHtml";
import { DownloadIcon } from "../../assets/styles/polls/icons";

export default function PollsList(props) {
  const navigate = useNavigate();

  const [currentActivePage, setCurrentActivePage] = useState(1);
  const [currentArchivedPage, setCurrentArchivedPage] = useState(1);
  const [archived, setArchived] = useState(false);

  const [filterText, setFilterText] = useState("");

  const [csvData, setCsvData] = useState([]);
  // const [csvHeaders, setCsvHeaders] = useState([]);

  const [pollResult, showPollResult] = useState(false);
  const [pollId, setPollId] = useState("");

  const [sortTypes, setSortTypes] = useState("");

  const [resultLoading, setResultLoading] = useState(false);

  const [sortOptions] = useState([
    { key: 111000, text: "Select Option", value: "", sort: "desc" },
    {
      key: 211000,
      text: "Multiple Choice",
      value: "multiple-choice",
      sort: "desc",
    },
    { key: 311000, text: "Yes/No", value: "yes-no", sort: "desc" },
    { key: 411000, text: "Scale", value: "rating", sort: "desc" },
  ]);


  useEffect(() => {
    props.fetch(currentActivePage, archived, filterText?.toLowerCase(), sortTypes);
  }, [currentActivePage, archived, filterText, sortTypes]);

  const renderAnnouncementBanner = () => {
    return (
      <Message icon positive>
        <Icon name="bullhorn" />
        <Message.Content>
          <p>
            We are working on adding new widgets for your emails! The first ones
            are polls for emails so that you can engage your users more and
            collect data.
          </p>
          <p>
            Polls are free to use for now. We will be adding new features and
            poll types in the coming weeks. Polls will be a paid feature in 2025
          </p>
        </Message.Content>
      </Message>
    );
  };

  const handlePageChange = (tab, activePage) => {
    if (tab === "active") setCurrentActivePage(activePage);
    if (tab === "archived") setCurrentArchivedPage(activePage);
  };

  const handleFilterChange = (e) => {
    const value = e.target.value;
    setFilterText(value);
  };

  const formatDate = (date) => moment(date).format("MMM DD, YYYY hh:mm A");

  const handleEditPoll = (pollId) => () => navigate(`/poll/${pollId}`);

  const handleArchive = (archived, id) => {
    const data = { archived, id };
    props.archive(data);
  };

  // const getFilteredPolls = (status) => {
  //   const totalPolls = props.polls?.data?.data || [];
  //   const filterText =
  //     status === "active" ? filterTextActive : filterTextArchived;
  //   const filteredPolls = totalPolls?.filter((poll) => {
  //     const matchesStatus =
  //       status === "active" ? !poll.archived : poll.archived;
  //     const matchesFilter = poll.title.toLowerCase().includes(filterText);
  //     const matchesSortingOption = !sortTypes || poll.poll_type === sortTypes;
  //     return matchesStatus && matchesFilter && matchesSortingOption;
  //   });

  //   return filteredPolls;
  // };

  const fetchAndDownloadCSV = async (slug) => {
    const jwtToken = props.user.jwt;
    try {
      setResultLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_DOMAIN_URL}/api/v1/polls_response/aggregate?poll_slug=${slug}`,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );

      const responseData = response.data.data;

      setCsvData(responseData);
      setResultLoading(false);
    } catch (error) {
      setResultLoading(false);
      console.error("Error fetching poll response:", error);
    }
  };

  const renderTableContents = (status) => {
    const paginatedPolls = props?.polls?.data?.data;
    const currentPage = props?.polls?.data?.meta?.current_page || 1;
    const totalPages = props?.polls?.data?.meta?.total_pages || 1;

    // const totalPages = Math.ceil(filteredPolls.length / itemsPerPage);
    // const startIndex = (currentPage - 1) * itemsPerPage;
    // const paginatedPolls = filteredPolls.slice(
    //   startIndex,
    //   startIndex + itemsPerPage
    // );

    return (
      <>
        <div className="polls_content">
          <div>
            <Dropdown
              placeholder="Sort"
              selection
              defaultValue=""
              options={sortOptions}
              onChange={(e, { value }) => {
                setSortTypes(value);
              }}
            />
          </div>
          <div>
            <Input
              className={gridCss.gridSearchText}
              icon
              iconPosition="left"
              placeholder="Search"
              value={filterText}
              onChange={handleFilterChange}
            >
              <input />
              <Icon name="search" />
            </Input>
          </div>
        </div>
        {paginatedPolls?.length >= 1 ? (
          <>
            <Table basic className={tableCss.tableBorder}>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Name</Table.HeaderCell>
                  <Table.HeaderCell>Poll Type</Table.HeaderCell>
                  <Table.HeaderCell>Creation Date</Table.HeaderCell>
                  <Table.HeaderCell>End Date</Table.HeaderCell>
                  <Table.HeaderCell>Responses</Table.HeaderCell>
                  <Table.HeaderCell>Actions</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row className={tableCss.tableRowBackground}>
                  <Table.HeaderCell className={tableCss.tableCol} colSpan={"6"}>
                    {paginatedPolls?.length} total polls
                  </Table.HeaderCell>
                </Table.Row>
                {paginatedPolls?.map((poll) => (
                  <Table.Row
                    key={poll.id}
                    className={
                      poll.template_data.hasEndDate &&
                      poll.template_data.isPollExpired
                        ? tableCss.pollExpired
                        : ""
                    }
                  >
                    <Table.Cell>
                      {poll.title}
                    </Table.Cell>
                    <Table.Cell>{poll.poll_type}</Table.Cell>
                    <Table.Cell>{formatDate(poll.created_at)}</Table.Cell>
                    <Table.Cell>
                      {poll.template_data.hasEndDate &&
                        formatDate(poll.ends_at)}
                    </Table.Cell>
                    <Table.Cell>
                      <div className="polls_report_body">
                        <span>{poll.total_responses}</span>
                        <span
                          className="polls_report"
                          onClick={() => {
                            showPollResult(true);
                            setPollId(poll);
                            fetchAndDownloadCSV(poll.slug);
                          }}
                        >
                          <DownloadIcon />
                          Report
                        </span>
                      </div>
                    </Table.Cell>
                    <Table.Cell className={tableCss.actionDiv}>
                      <Popup
                        inverted
                        trigger={
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={handleEditPoll(poll.id)}
                          >
                            <EditIconComponent />
                          </span>
                        }
                        content="Edit"
                        position="top center"
                      />
                      <Popup
                        inverted
                        trigger={
                          <span style={{ cursor: "pointer" }}>
                            <Clipboard
                              component="span"
                              data-clipboard-text={generateHtml(poll, "center")}
                            >
                              <Icon
                                name="linkify"
                                style={{ color: "#4E84A1" }}
                              />
                            </Clipboard>
                          </span>
                        }
                        content="Copy Code"
                        position="top center"
                      />
                      <Popup
                        inverted
                        trigger={
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              handleArchive(!poll.archived, poll.id)
                            }
                          >
                            <DeleteIconComponent />
                          </span>
                        }
                        content={poll.archived ? "Unarchive" : "Archive"}
                        position="top center"
                      />
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>

            <PollResult
              pollResult={pollResult}
              showPollResult={showPollResult}
              poll={pollId}
              jwtToken={props?.user.jwt}
              csvData={csvData}
              resultLoading={resultLoading}
            />

            <div style={{ display: "flex", justifyContent: "end" }}>
              <Pagination
                activePage={currentPage}
                onPageChange={(e, { activePage }) =>
                  handlePageChange(status, activePage)
                }
                totalPages={totalPages}
                lastItem={null}
                firstItem={null}
                ellipsisItem={{
                  content: <Icon name="ellipsis horizontal" />,
                  icon: true,
                }}
                prevItem={{
                  content: (
                    <span>
                      <LeftArrowIconComponent />
                    </span>
                  ),
                  icon: true,
                }}
                nextItem={{
                  content: (
                    <span>
                      <RightArrowIconComponent />
                    </span>
                  ),
                  icon: true,
                }}
              />
            </div>
          </>
        ) : filterText ? (
          <div className={tableCss.zero}>No Result Found</div>
        ) : (
          <div className={tableCss.zero}>
            You do not currently have any{" "}
            {status === "active" ? "active" : `archived`} polls.
          </div>
        )}
      </>
    );
  };

  const renderTabs = () => {
    const tables = [
      { menuItem: "Active Polls", render: renderTable("active") },
      { menuItem: "Archived Polls", render: renderTable("archived") },
    ];

    return <Tab menu={{ secondary: true, pointing: true }} panes={tables} />;
  };

  const renderTable = (status) => () => {
    setArchived(status === "active" ? false : true);
    return (
      <Tab.Pane as="div" attached="false">
        {renderTableContents(status)}
      </Tab.Pane>
    );
  };

  return (
    <div>
      {renderAnnouncementBanner()}
      <div id="polls-list" className={tableCss.tableContainer}>
        <Header as="h1">Polls</Header>
        <div className={tableCss.tableActions}>
          <Link to="/poll/new">
            <Button className={css.primaryButton}>Create New</Button>
          </Link>
        </div>
        {renderTabs()}
      </div>
    </div>
  );
}
